'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * batman核心模块
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _zoroMtop = require('@alife/zoro-mtop');

var _zoroMtop2 = _interopRequireDefault(_zoroMtop);

var _zoroCookie = require('@alife/zoro-cookie');

var _zoroCookie2 = _interopRequireDefault(_zoroCookie);

var _tab = require('@alife/zoro-base/lib/tab');

var _tab2 = _interopRequireDefault(_tab);

var _zoroArms = require('@alife/zoro-arms');

var _zoroArms2 = _interopRequireDefault(_zoroArms);

var _loading = require('@alife/zoro-base/lib/loading');

var _loading2 = _interopRequireDefault(_loading);

var _join = require('./join');

var _join2 = _interopRequireDefault(_join);

var _login = require('./login');

var _login2 = _interopRequireDefault(_login);

var _sns = require('./sns');

var _sns2 = _interopRequireDefault(_sns);

var _coupon = require('./coupon');

var _coupon2 = _interopRequireDefault(_coupon);

var _i18n = require('./i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Batman = (_temp = _class = function (_React$Component) {
    (0, _inherits3.default)(Batman, _React$Component);

    function Batman(props) {
        (0, _classCallCheck3.default)(this, Batman);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Batman.__proto__ || Object.getPrototypeOf(Batman)).call(this, props));

        _this.isMobile = /(iPhone|Android|AliApp)/i.test(navigator.userAgent);
        _this.isRegisterCtr = false;
        _this.isLoginCtr = false;

        _this.onTabChange = function (tab) {
            _this.setState({
                tab: tab
            }, function () {
                _this.getSns.snsCtr(tab);
                _this.tabCtr(tab);
            });

            if (tab === 'join') {
                (0, _util.clickDot)({
                    objectType: 'tab',
                    buttonType: 'register',
                    objectValue: 'tab_register'
                });
            } else if (tab) {
                (0, _util.clickDot)({
                    objectType: 'tab',
                    buttonType: 'sign_in',
                    objectValue: 'tab_sign_in'
                });
            }
        };

        _this.mailSignIn = function (data) {
            _this.setState({
                tab: 'login'
            });

            _this.loginNode.initLoginFrame({ loginId: data });
        };

        _this.afterLogin = function () {
            var pageType = 'buyer_login';
            if (_zoroCookie2.default.isSeller()) {
                pageType = 'seller_login';
            }

            (0, _util.clickDot)({
                pageType: pageType,
                buttonType: 'batman_login_success'
            });

            _this.props.afterLogin();
            _this.props.always();
        };

        _this.afterJoin = function (type) {
            if (type === 'mail') {
                (0, _util.clickDot)({
                    pageType: 'buyer_join',
                    buttonType: 'batman_email_join_success'
                });
            }
            if (type === 'phone') {
                (0, _util.clickDot)({
                    pageType: 'buyer_join',
                    buttonType: 'batman_phone_join_success'
                });
            }

            _this.props.afterJoin();
            _this.props.always();
        };

        _this.afterWithCouponJoin = function () {
            (0, _util.clickDot)({
                pageType: 'buyer_join',
                buttonType: 'batman_join_success'
            });

            _this.props.afterWithCouponJoin();
        };

        _this.showCoupon = function (data) {
            _this.setState({
                isShowCoupon: true,
                couponData: data
            });
        };

        _this.toggleMask = function (show) {
            _this.setState({
                isShowLoading: show
            });
        };

        _this.batmanNav = function (boolean) {
            _this.setState({
                ishideNav: boolean
            });
        };

        _this.showSNS = function (boolean) {
            _this.setState({
                isShowSNS: boolean
            });
        };

        _this.getConfigInfo = function (type, theme) {
            var middleData = void 0;

            if (type === 'join') {
                var showPhoneRegister = void 0;var isRegisterPhone = void 0;
                if (theme === 'ONLY_EMAIL') {
                    showPhoneRegister = false;
                } else if (theme === 'EMAIL_FIRST') {
                    showPhoneRegister = true;
                    isRegisterPhone = false;
                } else if (theme === 'PHONE_FIRST') {
                    showPhoneRegister = true;
                    isRegisterPhone = true;
                }
                middleData = {
                    showPhoneRegister: showPhoneRegister,
                    isRegisterPhone: isRegisterPhone
                };
            } else if (type === 'login') {
                var showPhoneLogin = void 0;
                if (theme === 'ONLY_EMAIL') {
                    showPhoneLogin = false;
                } else if (theme === 'EMAIL_FIRST') {
                    showPhoneLogin = true;
                } else if (theme === 'PHONE_FIRST') {
                    showPhoneLogin = true;
                }
                middleData = {
                    showPhoneLogin: showPhoneLogin
                };
            }

            return middleData;
        };

        _this.state = {
            tab: _this.props.tab,
            isShowCoupon: false,
            isShowLoading: false,
            ishideNav: false, // 是否隐藏tab导航
            isShowSNS: true,
            joinUiConfig: null,
            otherBenefits: null,
            loginUiConfig: null,
            showPhoneRegister: false, // 展示手机注册
            isRegisterPhone: false, // 是否展示手机注册
            showPhoneLogin: false, // 展示手机登录
            havanaQueryStr: ''
            // country: 'US' // 当前国家
        };

        _this.batmanNav = _this.batmanNav.bind(_this);
        _this.showSNS = _this.showSNS.bind(_this);
        return _this;
    } // 是否是手机模式

    // 是否注册tab已曝光

    (0, _createClass3.default)(Batman, [{
        key: 'componentDidMount',
        // 是否登录tab已曝光

        value: function componentDidMount() {
            var _this2 = this;

            this.tabCtr(this.props.tab);

            if (window.login_page_config) {
                var data = window.login_page_config;
                var middlePhoneRegister = void 0;var middlePhoneLogin = void 0;
                // 渲染join
                if (data.registerTheme) {
                    middlePhoneRegister = this.getConfigInfo('join', data.registerTheme);
                }
                // 渲染login
                if (data.loginTheme) {
                    middlePhoneLogin = this.getConfigInfo('login', data.loginTheme);
                }
                this.setState((0, _extends3.default)({
                    joinUiConfig: data,
                    loginUiConfig: data
                }, middlePhoneRegister, middlePhoneLogin, {
                    havanaQueryStr: this._handleHavanaQueryStr(middlePhoneLogin.showPhoneLogin, data.country)
                }));
            } else {
                // 注册配置接口
                if (!this.props.joinParams.registerFrom) {
                    // 传空值
                    this.props.joinParams.registerFrom = (0, _util.isMobile)() ? 'AE_MSITE_REGISTER' : 'AE_MAIN_POPUP_WHOLESALE';
                }
                (0, _util.getSnsList)(this.props.joinParams.registerFrom).then(function (data) {
                    var middleRegisterData = void 0;
                    if (data.registerTheme) {
                        middleRegisterData = _this2.getConfigInfo('join', data.registerTheme);
                    }
                    _this2.setState((0, _extends3.default)({
                        joinUiConfig: data
                    }, middleRegisterData, {
                        havanaQueryStr: _this2._handleHavanaQueryStr(_this2.state.showPhoneLogin, data.country)
                    }));
                }).catch(function (err) {
                    _zoroArms2.default.error(err);
                });

                // 登录配置接口
                if (!this.props.loginParams.loginFrom) {
                    // 传空值
                    this.props.loginParams.loginFrom = (0, _util.isMobile)() ? 'AE_MSITE_LOGIN' : 'AE_MAIN_LOGIN';
                }
                (0, _util.getSnsListLogin)(this.props.loginParams.loginFrom).then(function (data) {
                    var middleLoginData = void 0;
                    if (data.loginTheme) {
                        middleLoginData = _this2.getConfigInfo('login', data.loginTheme);
                    }
                    _this2.setState((0, _extends3.default)({
                        loginUiConfig: data
                    }, middleLoginData, {
                        havanaQueryStr: _this2._handleHavanaQueryStr(middleLoginData.showPhoneLogin, data.country)
                    }));
                }).catch(function (err) {
                    _zoroArms2.default.error(err);
                });
            }

            // 是否发送新人优惠券
            if (this.props.joinParams.isSendOtherCoupon) {
                var paramObj = {
                    appVersion: '300',
                    invitationScenario: this.props.joinParams && this.props.joinParams.extendUrlSnsParams && this.props.joinParams.extendUrlSnsParams.invitationScenario ? this.props.joinParams.extendUrlSnsParams.invitationScenario : '',
                    positionId: 'webRegisterPromotionTip' // 默认填1即可
                };
                _zoroMtop2.default.request({
                    api: 'mtop.aliexpress.usertouch.houyi.launchrule.runtime.pull',
                    v: '1.0',
                    data: paramObj
                }).then(function (resJson) {
                    _this2._afterGetOtherCoupon(resJson);
                }, function (res) {
                    _zoroArms2.default.error(res);
                });
            }
        }
    }, {
        key: '_handleHavanaQueryStr',
        value: function _handleHavanaQueryStr(showPhoneLogin, country) {
            return '&cssUrl=https://g.alicdn.com/ae/glologin-ui/0.0.13/reset-havana-new-page.css&showMobilePwdLogin=' + showPhoneLogin + '&defaultCountryCode=' + country;
            // return `&cssUrl=https://i.alicdn.com/noah-static/4.0.2/common/css/reset-havana-new-page.css&showMobilePwdLogin=${showPhoneLogin}&defaultCountryCode=${country}`;
        }
    }, {
        key: '_afterGetOtherCoupon',
        value: function _afterGetOtherCoupon(resJson) {
            var middleOtherBenefits = void 0;
            if (resJson && resJson.data) {
                if (resJson.data.activities && resJson.data.activities[0] && resJson.data.activities[0].positionGroupList && resJson.data.activities[0].positionGroupList[0] && resJson.data.activities[0].positionGroupList[0].positionList) {
                    middleOtherBenefits = resJson.data.activities[0].positionGroupList[0].positionList[0] || {};
                }
            } else if (resJson.activities && resJson.activities[0] && resJson.activities[0].positionGroupList && resJson.activities[0].positionGroupList[0] && resJson.activities[0].positionGroupList[0].positionList) {
                middleOtherBenefits = resJson.activities[0].positionGroupList[0].positionList[0] || {};
            }
            this.setState({
                otherBenefits: middleOtherBenefits
            });
        }

        // tab曝光打点

    }, {
        key: 'tabCtr',
        value: function tabCtr(tab) {
            if (tab === 'join' && !this.isRegisterCtr) {
                this.isRegisterCtr = true;
                (0, _util.ctrDot)({
                    expType: 'register_tab'
                });
            }
            if (tab === 'login' && !this.isLoginCtr) {
                this.isLoginCtr = true;
                (0, _util.ctrDot)({
                    expType: 'signin_tab'
                });
            }
        }

        // 点击tab切换


        // 点击sign in ，跳转到登录tab


        // login成功


        // 注册成功


        /**
         * 带coupon注册成功
         * 当页面为dialog时，给dialog绑定关闭事件，然后刷新
         */


        // 获取配置接口信息

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var className = (0, _classnames2.default)('batman', {
                'batman-dialog': this.props.type === 'dialog'
            }, this.props.className);

            if (this.state.isShowCoupon) {
                return _react2.default.createElement(
                    'div',
                    { className: className },
                    _react2.default.createElement(_coupon2.default, { data: this.state.couponData })
                );
            } else {
                return _react2.default.createElement(
                    'div',
                    { className: className },
                    _react2.default.createElement('div', { className: 'login-logo' }),
                    _react2.default.createElement(
                        _tab2.default,
                        {
                            onChange: this.onTabChange,
                            activeKey: this.state.tab,
                            lazyLoad: false,
                            navClassName: this.state.ishideNav ? 'batman-nav' : ''
                        },
                        this.props.hasJoin ? _react2.default.createElement(
                            _tab2.default.Item,
                            { title: _i18n2.default.REGISTER, key: 'join' },
                            _react2.default.createElement(
                                _loading2.default,
                                { className: 'loading', visible: this.state.isShowLoading, size: 'medium' },
                                _react2.default.createElement(_join2.default, (0, _extends3.default)({
                                    isMobile: this.isMobile
                                }, this.props.joinParams, {
                                    mailSignIn: this.mailSignIn,
                                    otherBenefits: this.state.otherBenefits,
                                    afterJoin: this.afterJoin,
                                    afterWithCouponJoin: this.afterWithCouponJoin,
                                    afterJoinInit: this.props.afterJoinInit,
                                    showCoupon: this.showCoupon,
                                    toggleMask: this.toggleMask,
                                    batmanNav: this.batmanNav,
                                    showSNS: this.showSNS,
                                    joinUiConfig: this.state.joinUiConfig,
                                    showPhoneRegister: this.state.showPhoneRegister,
                                    isRegisterPhone: this.state.isRegisterPhone,
                                    registerFrom: this.props.joinParams.registerFrom
                                }))
                            )
                        ) : null,
                        _react2.default.createElement(
                            _tab2.default.Item,
                            { title: _i18n2.default.SIGN, key: 'login' },
                            _react2.default.createElement(
                                _loading2.default,
                                { className: 'loading', visible: this.state.isShowLoading, size: 'medium' },
                                this.state.havanaQueryStr ? _react2.default.createElement(_login2.default, {
                                    ref: function ref(node) {
                                        _this3.loginNode = node;
                                    },
                                    scene: this.props.loginParams.loginFrom,
                                    havanaQueryStr: this.state.havanaQueryStr,
                                    afterLoginInit: this.props.afterLoginInit,
                                    isMobile: this.isMobile,
                                    enableSmartLock: true,
                                    afterLogin: this.afterLogin,
                                    toggleMask: this.toggleMask
                                }) : null
                            )
                        )
                    ),
                    this.state.isShowSNS ? _react2.default.createElement(_sns2.default, {
                        tab: this.state.tab,
                        ref: function ref(c) {
                            _this3.getSns = c;
                        },
                        snsReturnUrl: this.props.snsReturnUrl,
                        joinUiConfig: this.state.joinUiConfig,
                        loginUiConfig: this.state.loginUiConfig
                    }) : null,
                    this.props.region ? _react2.default.createElement(
                        'p',
                        { className: 'quick-access-guid' },
                        _i18n2.default.GUID,
                        _react2.default.createElement(
                            'a',
                            { href: 'https://login.aliexpress.com/join/seller/wholesaleJoin.htm', target: '_blank' },
                            _i18n2.default.GUID_HREF
                        )
                    ) : ''
                );
            }
        }
    }]);
    return Batman;
}(_react2.default.Component), _class.propTypes = {
    type: _propTypes2.default.oneOf(['dialog', 'page']),
    tab: _propTypes2.default.oneOf(['join', 'login']),
    region: _propTypes2.default.bool,
    hasJoin: _propTypes2.default.bool,
    joinParams: _propTypes2.default.shape({
        sessionId: _propTypes2.default.string,
        couponCode: _propTypes2.default.string,
        registerFrom: _propTypes2.default.string,
        registerAction: _propTypes2.default.string,
        isSendCoupon: _propTypes2.default.bool,
        isSendOtherCoupon: _propTypes2.default.bool
    }),
    loginParams: _propTypes2.default.shape({
        loginFrom: _propTypes2.default.string
    }),
    afterJoin: _propTypes2.default.func,
    afterLogin: _propTypes2.default.func,
    always: _propTypes2.default.func,
    className: _propTypes2.default.string,
    afterLoginInit: _propTypes2.default.func,
    afterJoinInit: _propTypes2.default.func,

    afterWithCouponJoin: _propTypes2.default.func
}, _class.defaultProps = {
    tab: _zoroCookie2.default.isNewUser() ? 'join' : 'login', // 当未设置默认状态时默认展示的tab
    region: !!(_zoroCookie2.default.getRegion() === 'IT' || _zoroCookie2.default.getRegion() === 'TR'),
    hasJoin: true,
    afterJoin: _util.noop,
    afterLogin: _util.noop,
    afterLoginInit: _util.noop,
    afterJoinInit: _util.noop,
    always: _util.noop,
    afterWithCouponJoin: _util.noop,
    joinParams: {
        registerFrom: (0, _util.isMobile)() ? 'AE_MSITE_REGISTER' : 'AE_MAIN_POPUP_WHOLESALE',
        isSendOtherCoupon: false
    },
    loginParams: {
        loginFrom: (0, _util.isMobile)() ? 'AE_MSITE_LOGIN' : 'AE_MAIN_LOGIN'
    }
}, _temp);
exports.default = Batman;